export const ConfigData = [
  {
    id: "station_id",
    name: "Station ID",
    isShow: true,
    width: "100px",
    filter: true,
  },
  {
    id: "station_name",
    name: "Station Name",
    isShow: true,
    width: "300px",
    filter: true,
  },
  {
    id: "latitude",
    name: "Latitude",
    isShow: true,
    width: "150px",
    filter: true,
  },
  {
    id: "longitude",
    name: "Longitude",
    isShow: true,
    width: "150px",
    filter: true,
  },
  {
    id: "created_at",
    name: "Created On",
    isShow: true,
    width: "160px",
    filter: false,
    format: "date-time"
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["View Details", "Delete"],
    permission: {
      ["View Details"]: {
        id: "View Details",
        permission: ["bus_booking.access_bus_booking_station"]
      },
      ["Delete"]: {
        id: "Delete",
        permission: ["bus_booking.delete_bus_booking_station"]

      },
    },
  },
];
